export const TEST_IDS = {
  APP_GO_BACK_LINK: 'app-go-back-link',
  APP_SUPPORT_LINK: 'app-support-link',
  APP_STATUS_LINK: 'app-status-link',
  APP_LINK_WITH_ICON: 'app-link-with-icon',
  FACET_DROPDOWN_TRIGGERS: 'facet-dropdown--trigger'
};